import { Route } from "react-router";
import { homeLoader } from "@routes/loaders/homeLoader";
import { CALENDAR, CHAT, CHAT_MAIN, DASHBOARD, PATIENTS } from "@routes/routes";
import {
  CalendarPage,
  ChatPage,
  ClientsPage,
  Error404Page,
  HomePage,
} from "@routes/lazyPages";

export const coreRoutes = (
  <>
    <Route path="*" lazy={Error404Page} />
    <Route path={DASHBOARD} loader={homeLoader} lazy={HomePage} />

    <Route path={CALENDAR} lazy={CalendarPage} />

    <Route path={PATIENTS} lazy={ClientsPage} />

    <Route path={CHAT_MAIN} lazy={ChatPage} />
    <Route path={CHAT} lazy={ChatPage} />
  </>
);
